import { render, staticRenderFns } from "./TaskDetailDialog.vue?vue&type=template&id=650ff85c"
import script from "./TaskDetailDialog.vue?vue&type=script&lang=js"
export * from "./TaskDetailDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports